import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { navLinks, agent } from "../mock";
import { Button } from "./ui/button";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <>
      {/* Top announcement bar */}
      <div className="bg-[#d4af37] text-[#141210] text-center text-[11px] md:text-xs tracking-luxury py-2 px-4 font-semibold uppercase">
        No Minimum Credit Score for VA Loans* · FHA From a 500 Score
      </div>

      <header
        className={`sticky top-0 z-50 transition-all duration-500 ${
          scrolled
            ? "bg-[#141210]/95 backdrop-blur-md shadow-[0_8px_30px_-12px_rgba(0,0,0,0.6)]"
            : "bg-[#141210]"
        }`}
      >
        <nav className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="flex items-center justify-between h-[78px]">
            {/* Brand logo */}
            <Link to="/" className="flex items-center group">
              <img
                src={agent.logo}
                alt="Kristy Russo, Realtor — Buy · Sell · Invest"
                className="h-11 md:h-14 w-auto transition-transform duration-300 group-hover:scale-[1.03]"
              />
            </Link>

            {/* Desktop links */}
            <div className="hidden lg:flex items-center gap-7">
              {navLinks.map((l) => {
                const active = location.pathname === l.path;
                return (
                  <Link
                    key={l.path}
                    to={l.path}
                    className={`relative text-[13px] tracking-wide uppercase transition-colors duration-300 ${
                      active ? "text-[#d4af37]" : "text-[#d9cdb8] hover:text-[#d4af37]"
                    }`}
                  >
                    {l.label}
                    <span
                      className={`absolute -bottom-1.5 left-0 h-px bg-[#d4af37] transition-all duration-300 ${
                        active ? "w-full" : "w-0"
                      }`}
                    />
                  </Link>
                );
              })}
            </div>

            <div className="hidden lg:flex items-center">
              <a href={agent.phoneHref}>
                <Button className="bg-[#d4af37] hover:bg-[#c19a2e] text-[#141210] rounded-full px-5 h-10 text-xs tracking-luxury uppercase font-semibold">
                  <Phone className="w-3.5 h-3.5 mr-2" /> {agent.phone}
                </Button>
              </a>
            </div>

            {/* Mobile toggle */}
            <button
              className="lg:hidden text-[#d9cdb8] p-2"
              onClick={() => setOpen((o) => !o)}
              aria-label="Menu"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </nav>

        {/* Mobile menu */}
        <div
          className={`lg:hidden overflow-hidden transition-all duration-500 ease-out bg-[#141210] border-t border-[#2a241d] ${
            open ? "max-h-[560px]" : "max-h-0"
          }`}
        >
          <div className="px-6 py-5 flex flex-col gap-1">
            {navLinks.map((l) => {
              const active = location.pathname === l.path;
              return (
                <Link
                  key={l.path}
                  to={l.path}
                  className={`py-3 border-b border-[#2a241d] text-sm tracking-wide uppercase ${
                    active ? "text-[#d4af37]" : "text-[#d9cdb8]"
                  }`}
                >
                  {l.label}
                </Link>
              );
            })}
            <a href={agent.phoneHref} className="mt-4">
              <Button className="w-full bg-[#d4af37] hover:bg-[#c19a2e] text-[#141210] rounded-full h-11 tracking-luxury uppercase text-xs font-semibold">
                <Phone className="w-4 h-4 mr-2" /> Call {agent.phone}
              </Button>
            </a>
          </div>
        </div>
      </header>
    </>
  );
};

export default Navbar;
